import exp from "constants";
import { LoadState } from "../../constants/enums";
import { IStudentReport, IStudentReportState } from "./type";

export const defaultStudentReport: IStudentReport = {
  customer_fact_uuid: "",
  customer_name: "",
  customer_code: "",
  organizations_uuid: "",
  organizations_name: "",
  courses_uuid: "",
  courses_name: "",
  batch: "",
  academic_year: "",
  hostel_required: "",
  total_fee: 0,
  fees_paid: 0,
  pending_fee: 0,
  fine_amount: 0,
  fee_type_details: [],
};

export const defaultStudentReportState: IStudentReportState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  studentReport: {
    data: defaultStudentReport,
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  amount: {
    totalFeeAmount: 0,
    totalPaidFee: 0,
    pendingFee: 0,
  },
};
